import { useState } from "react";
import Logo from "../img/Logo_signcast_big-1080x322.png";
import { Link, useNavigate } from "react-router-dom";
import useAuthStore from "../store/authStore"; // Import auth store

const SignUp = () => {
  const [formData, setFormData] = useState({
    email: "",
    fullName: "",
    contactNumber: "",
    password: ""
  });
  
  const { initiateSignup, isLoading, error, clearError } = useAuthStore();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    clearError();
    
    // Basic validation
    if (!formData.email || !formData.fullName || !formData.contactNumber || !formData.password) {
      return;
    }
    
    const success = await initiateSignup(formData);
    
    // Navigate to verification page instead of dashboard
    if (success) {
      navigate('/verify');
    }
  };

  return (
    <div className="login-container bg-blue-50 w-full h-screen flex justify-center items-center">
      <div className="bg-white w-[420px] h-[580px] rounded-lg shadow-lg">
        <div className="flex flex-row items-center p-10">
          <img className="w-28 h-auto" src={Logo} alt="Logo" />
          <div className="ml-auto flex flex-col justify-start text-start items-start">
            <p className="text-gray-500 text-[14px]">Have an Account?</p>
            <span className="text-blue-500 text-[14px] no-underline">
              <Link 
                to="/login"
                style={{ textDecoration: 'none' }}
              >
                Sign in
              </Link>
            </span>
          </div>
        </div>
        
        <h1 className="text-4xl font-bold pl-10">Sign up</h1>
        
        {error && (
          <p className="text-red-500 text-[12px] text-center mt-2">{error}</p>
        )}
        
        <form onSubmit={handleSignUp}>
          <div className="flex flex-col pl-10">
            <p className="text-black text-[14px] pt-6 pb-2">
              Enter your email address
            </p>
            <input
              name="email"
              className="text-[14px] pl-4 w-[340px] h-[45px] rounded-lg border-2 border-gray-300"
              type="email"
              placeholder="Email address"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="flex flex-row justify-between px-10">
            <div className="flex flex-col">
              <p className="text-black text-[14px] pt-6 pb-2">
                Full name
              </p>
              <input
                name="fullName"
                className="text-[14px] pl-4 w-[160px] h-[45px] rounded-lg border-2 border-gray-300"
                type="text"
                placeholder="Full name"
                value={formData.fullName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="flex flex-col">
              <p className="text-black text-[14px] pt-6 pb-2">
                Contact Number
              </p>
              <input
                name="contactNumber"
                className="text-[14px] pl-4 w-[160px] h-[45px] rounded-lg border-2 border-gray-300"
                type="text"
                placeholder="Contact Number"
                value={formData.contactNumber}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="flex flex-col pl-10">
            <p className="text-black text-[13px] pt-6 pb-2">
              Enter your password
            </p>
            <input
              name="password"
              className="text-[14px] pl-4 w-[340px] h-[45px] rounded-lg border-2 border-gray-300"
              type="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="flex flex-col p-10 rounded-lg">
            <button
              type="submit"
              disabled={isLoading}
              className="h-[41px] w-full bg-blue-500 text-white text-[14px] font-bold rounded-lg hover:bg-blue-600 transition-colors"
            >
              {isLoading ? "Please wait..." : "Continue"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignUp;
